import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { GetPartnerDetailData } from "@/types/partners";

import { getPartnerDetail } from "./partnersApi";

export const useGetPartnerDetailAPI = (
  appSubdomain: string,
  options?: Omit<
    UseQueryOptions<GetPartnerDetailData, Error, GetPartnerDetailData>,
    "queryKey" | "queryFn"
  >
) =>
  useQuery({
    queryKey: ["getPartnerDetail"],
    queryFn: () => getPartnerDetail(appSubdomain),
    ...options
  });
